var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.menu),function(item){return _c('v-list-item',{key:item.title,attrs:{"to":item.link,"exact":""}},[_c('v-list-item-action',[_c('v-icon',{attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))])],1),_c('v-list-item-content',[_vm._v(_vm._s(item.title))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }